module.exports = __webpack_public_path__ + "static/media/4.59ace825.jpg";